import { State } from '@progress/kendo-data-query';
import {
  NodeUserAccessControl,
  UploadedAccessControlInfo,
} from '../../Interfaces/AccessControl';
import { actionCreators } from './AccessControlState';

export const fetchAccessControlFilePath = async (
  dispatch: any,
  fileName: string
) => {
  return dispatch(actionCreators.fetchAccessControlFilePath(fileName));
};

export const fetchUploadedAccessControlCSV = async (
  dispatch: any,
  uploadedCSV: UploadedAccessControlInfo
) => {
  return dispatch(actionCreators.fetchUploadedAccessControlCSV(uploadedCSV));
};

export const savingAccessControlGridState = async (
  dispatch: any,
  dataState: State
) => {
  return dispatch(actionCreators.savingAccessControlGridState(dataState));
};

export const fetchLatestUploadAccessControlCSV = async (dispatch: any) => {
  return dispatch(actionCreators.getLatestUploadAccessControlCSV());
};
